import { styled } from '@linaria/react';

export const SeeAllOddsContainer = styled.div`
  display: flex;
  justify-content: end;
  align-self: center;
  grid-area: see-all-odds;
  margin: 0;
  position: relative;
  transform: translateY(-1px);

  @media (min-width: 768px) {
    transform: translateY(0);
    margin-left: 15px;
  }
`;
export const SeeAllOdds = styled.a`
  font-family: var(--ogm-font-family-2);
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  text-decoration: none;
  width: fit-content;
  position: relative;
  white-space: nowrap;
  display: flex;
  align-items: center;
  padding-right: 8px;

  &:hover {
    text-decoration: underline var(--ogm-text-body);
  }

  @media (min-width: 768px) {
    line-height: 19px;
    min-width: 70px;
  }
`;

export const LinkText = styled.span`
  color: var(--ogm-timberwolves);
  font-size: var(--cxy-fontSize-s);
`;

export const ArrowWrapper = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 5px;
`;
